import React from "react";
import Failure from "../svg/Failure";
import BackToStart from "./BackToStart";

const Failed = () => {
    return (
        <div>
            <Failure/>
            <div className="message">
                <p style={{textAlign: "center"}}>
          <span style={{display: "block", fontSize: "13px"}}>
            There was a problem adding funds to your account.
          </span>
                </p>
            </div>
            <div style={{textAlign: "center"}}>
                <BackToStart>Try Again</BackToStart>
            </div>
        </div>
    );
};

export default Failed;
